__webpack_require__.p = "/mi-assets/mi-static/mi-offers-renderer/phx-rel-R24.11.2-110824/_next/";